export default __webpack_public_path__ + "static/brand-logo-sizzling-6c97da3903c731bccd26956cb3f9ca7b.png";